import { render } from "./App.vue?vue&type=template&id=76c88580"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "L:\\Web\\htdocs\\Testroom\\gruene-mitte\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__